// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu-module--menu--1IDZ3","item":"menu-module--item--2-wzD","active":"menu-module--active--4Mffb","parent":"menu-module--parent--2PgEl","dark":"menu-module--dark--26RZf"};